export function ensureTrailingSlash(url) {
  return url.endsWith("/") ? url : `${url}/`;
}

export function ensureNoTrailingSlash(url) {
  return url.endsWith("/") ? url.slice(0, -1) : url;
}
